import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { 
  Package, 
  User, 
  Calendar, 
  PoundSterling
} from "lucide-react";
import { format } from "date-fns";
import { 
  computeOrderProgress, 
  getOrderStatusColor, 
  getProgressBarColor 
} from "@/utils/orderProgress";

interface OrderCardProps {
  order: any;
  onClick?: () => void;
}

export const OrderCard = ({ order, onClick }: OrderCardProps) => {
  const progress = computeOrderProgress(order);

  return (
    <Card className="overflow-hidden cursor-pointer hover:shadow-md transition-shadow" onClick={onClick}>
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <div className="space-y-2">
            <div className="flex items-center gap-3">
              <h3 className="text-base font-semibold">
                {order.sale?.deal?.title || `Order #${order.id.slice(0, 8)}`}
              </h3>
              <Badge className={getOrderStatusColor(order.status)}>
                {order.status.replace('_', ' ')}
              </Badge>
            </div>
            <div className="flex items-center gap-4 text-sm text-muted-foreground">
              {order.sale?.deal?.contact && (
                <div className="flex items-center gap-1">
                  <User className="h-4 w-4" />
                  <span>
                    {order.sale.deal.contact.first_name} {order.sale.deal.contact.last_name}
                  </span>
                </div>
              )}
              <div className="flex items-center gap-1">
                <Calendar className="h-4 w-4" />
                <span>{format(new Date(order.created_at), 'MMM dd, yyyy')}</span>
              </div>
              <div className="flex items-center gap-1">
                <Package className="h-4 w-4" />
                <span>{order.total_cameras} cameras, {order.total_images} images</span>
              </div>
              {order.sale?.total_amount && (
                <div className="flex items-center gap-1">
                  <PoundSterling className="h-4 w-4" />
                  <span>£{order.sale.total_amount}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </CardHeader>
      
      <CardContent>
        <div className="space-y-2">
          <div className="flex justify-between text-sm">
            <span className="font-medium">Order Progress</span>
            <span className="text-muted-foreground">{Math.round(progress)}% Complete</span>
          </div>
          <Progress value={progress} className={`h-2 ${getProgressBarColor(order.status)}`} />
        </div>
      </CardContent>
    </Card>
  );
};